import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPublicTeachers } from "../utils/publicProfile";
import HeaderComp from "./Components/HeaderComp";
import Footer from "./Components/Footer";
import { BsStars } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { useLang } from "../i18n/LanguageContext";

const ProfCard = ({ prof }) => {
  const { t } = useLang();
  return (
  <Link to={`/Teacher/${prof.id}`} className="group">
    <div className="bg-white rounded-2xl shadow-carte overflow-hidden hover:shadow-carte-hover transition-all hover:-translate-y-1 flex flex-col">
      <div className="h-32 bg-prune relative">
        <div className="absolute -bottom-10 left-6">
          <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden bg-prune-dark">
            {prof.profilePicture ? (
              <img src={prof.profilePicture} alt="" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white text-3xl font-bold">
                {prof.firstName ? prof.firstName[0] : "?"}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="pt-12 pb-6 px-6 flex-1 flex flex-col">
        <h3 className="font-bold text-stone-800 text-lg group-hover:text-prune transition-colors">
          {prof.firstName} {prof.lastName}
        </h3>
        <p className="text-sm text-stone-500 mt-1 line-clamp-2 flex-1">
          {prof.description || t("Professeur passionné·e par le partage des connaissances.")}
        </p>
        <span className="mt-4 inline-block text-xs font-semibold text-prune border border-prune rounded-full px-3 py-1 group-hover:bg-prune group-hover:text-white transition-all w-fit">
          {t("Voir le profil →")}
        </span>
      </div>
    </div>
  </Link>
  );
};

const Professeurs = () => {
  const [profs, setProfs] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const { t } = useLang();

  useEffect(() => {
    const load = async () => {
      try {
        setProfs(await getPublicTeachers());
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filtered = profs.filter(
    (p) =>
      `${p.firstName} ${p.lastName}`.toLowerCase().includes(search.toLowerCase()) ||
      (p.description || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-creme flex flex-col">
      <HeaderComp />

      {/* Hero */}
      <div className="bg-prune text-white py-12 px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-3">
          <BsStars className="text-or" size={22} />
          <h1 className="text-4xl md:text-5xl" style={{ fontFamily: "Alegreya, Georgia, serif", fontWeight: 700 }}>
            {t("Nos Professeurs")}
          </h1>
          <BsStars className="text-or" size={22} />
        </div>
        <p className="text-white/80 max-w-xl mx-auto text-sm">
          {t("Des passionné·es de tous horizons, prêt·es à partager leur savoir avec toi.")}
        </p>
        <div className="mt-6 max-w-md mx-auto relative">
          <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
          <input
            type="text"
            placeholder={t("Rechercher un professeur...")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-full text-stone-800 text-sm shadow-carte focus:outline-none focus:ring-2 focus:ring-or"
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full px-6 py-12 flex-1">
        {loading ? (
          <div className="text-center py-20 text-stone-400">{t("Chargement...")}</div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-20">
            <div className="text-5xl mb-4">🧙‍♀️</div>
            <p className="text-stone-500">{t("Aucun professeur trouvé.")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((prof) => (
              <ProfCard key={prof.id} prof={prof} />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Professeurs;
